import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, useStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import {OneMedia} from './gallery-layouts/one-media'
import {TwoMedia} from './gallery-layouts/two-media'
import {ThreeMedia} from './gallery-layouts/three-media'
import SanitizedHtml from '../../html-sanitizer'

export const Gallery = ({
    hasPaddings,
    variant = 'white',
    heading = '',
    bodycopy = '',
    mediaLayouts = [],
}) => {
    const styles = useStyleConfig('Gallery')

    const layoutTypes = {
        One: 'gallery_layout_one_media',
        Two: 'gallery_layout_two_media',
        Three: 'gallery_layout_three_media',
    }

    return (
        <Flex
            {...styles.container}
            flexDirection={'column'}
            data-testid="gallery"
            py={hasPaddings ? {base: remCalc(24), sm: remCalc(16)} : {}}
            backgroundColor={variant === 'black' ? 'background.dark' : 'background.default'}
        >
            <Flex {...styles.textblock} flexDirection={'column'}>
                {heading && (
                    <Text
                        as="h2"
                        textStyle="head-large"
                        fontWeight={'medium'}
                        color={variant === 'black' ? 'text.inverse' : 'text.default'}
                        {...styles.heading}
                    >
                        {heading}
                    </Text>
                )}
                {bodycopy && (
                    <SanitizedHtml
                        as={Box}
                        html={bodycopy}
                        textStyle="body-large"
                        fontWeight={'normal'}
                        color={variant === 'black' ? 'text.inverse' : 'text.default'}
                        {...styles.bodycopy}
                    />
                )}
            </Flex>
            <Flex {...styles.medias} flexDirection={'column'}>
                {mediaLayouts.map((layout, index) => {
                    switch (layout.type) {
                        case layoutTypes.One:
                            return <OneMedia media1={layout.media1} key={`one-media-${index}`} />
                        case layoutTypes.Two:
                            return (
                                <TwoMedia
                                    media1={layout.media1}
                                    media2={layout.media2}
                                    key={`two-media-${index}`}
                                />
                            )
                        case layoutTypes.Three:
                            return (
                                <ThreeMedia
                                    media1={layout.media1}
                                    media2={layout.media2}
                                    media3={layout.media3}
                                    key={`three-media-${index}`}
                                />
                            )
                        default:
                            return null
                    }
                })}
            </Flex>
        </Flex>
    )
}

Gallery.propTypes = {
    hasPaddings: PropTypes.bool,
    variant: PropTypes.string,
    heading: PropTypes.string,
    bodycopy: PropTypes.string,
    mediaLayouts: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            media1: PropTypes.shape({
                is_video: PropTypes.bool,
                video: PropTypes.arrayOf(PropTypes.shape()),
                image: PropTypes.shape(),
            }),
            media2: PropTypes.shape({
                is_video: PropTypes.bool,
                video: PropTypes.arrayOf(PropTypes.shape()),
                image: PropTypes.shape(),
            }),
            media3: PropTypes.shape({
                is_video: PropTypes.bool,
                video: PropTypes.arrayOf(PropTypes.shape()),
                image: PropTypes.shape(),
            }),
        }),
    ),
}
